import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { media } from "../utils/MediaQueries";
import { CountUp } from 'countup.js';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(CustomEase);



function homeBannerAnimation() {

  // Initialise homepaage teaser slider
  const homepageSwiperSlider = new Swiper('.js-homepage-slider', {
    observer: true, 
    observeParents: true,
    loop: true,
    //centeredSlides: true,
    //loopAdditionalSlides: 50,
    draggable: true,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    allowTouchMove: true,
    effect: 'slide',
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      // when window width is >= 320px
      760: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 480px
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      },
    },
    navigation: {
      nextEl: '.home-slider-next',
      prevEl: '.home-slider-prev',
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  // Initialise homepaage stats slider
  const homepageStatsSlider = new Swiper('.js-homepage-stats', {
    observer: true, 
    observeParents: true,
    loop: true,
    //centeredSlides: true,
    //loopAdditionalSlides: 50,
    draggable: true,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    allowTouchMove: true,
    effect: 'slide',
    spaceBetween: 40,
    slidesPerView: 1,
    breakpoints: {
      // when window width is >= 320px
      760: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 480px
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      // when window width is >= 640px
      1280: {
        slidesPerView: 4,
        spaceBetween: 40
      }
    },
    navigation: {
      nextEl: '.stat-slider-next',
      prevEl: '.stat-slider-prev',
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });



  // Split text banner titles
  const pageTitle = new SplitText(".js-homepage-banner-title", {type: "lines", tag: "span"});
  const sliderTitle = new SplitText(".js-homepage-slider-title", {type: "lines", tag: "span"});

  // Set up variables
  const logo = $('.top-nav__logo'); 
  const navButton = $('.js-nav-button-wrapper')
  const homepageBannerImage = $('.js-homepage-banner-img');
  const homepageBannerTitle = $('.js-homepage-banner-title span');
  const homepageBannerIntro = $('.js-homepage-banner-intro');
  const homeBannerCrest = $('.js-homepage-banner-crest');

  const homepageSliderSection = $('.homepage-slider');
  const homepageSliderTitle = $('.js-homepage-slider-title span');
  const homepageSlider = $('.js-homepage-slider');
  const homepageSliderSlideOne = $('.js-homepage-slider [data-swiper-slide-index="0"]');
  const homepageSliderSlideTwo = $('.js-homepage-slider [data-swiper-slide-index="1"]');
  const homepageSliderSlideThree = $('.js-homepage-slider [data-swiper-slide-index="2"]');

  const homepageVideo = document.querySelector('.js-homepage-video');
  const homepageStatsTitle = document.querySelector('.js-stats-title');
  const homepageStatSlider = document.querySelector('.stat-slider-wrapper');
  const homepageIsi = document.querySelector('.js-mobile-isi');

  
  if (media.md) {
    // Small screens

    // Banner Loading animation
    const loadBannerTL = gsap.timeline();
    loadBannerTL.add( function() { navButton.addClass('light'); } );
    loadBannerTL.from( homepageBannerImage, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" });
    loadBannerTL.from( homepageBannerTitle, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerTL.from( homepageBannerIntro, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.0" );
    loadBannerTL.from( logo, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=0.9" );
    loadBannerTL.from( navButton, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.2" );
    
    const mobileSliderTL = gsap.timeline({ paused: false, });  
    mobileSliderTL.delay(0.6);
    mobileSliderTL.fromTo( homepageSliderTitle, { clipPath: "inset(0% 0% 100% 0%)" }, { clipPath: "inset(0% 0% -5% 0%)" } );
    mobileSliderTL.fromTo( homepageSlider, { opacity: 0, y: 70, }, { opacity: 1, y: 0, ease: "none", }, ">" );
    ScrollTrigger.create({
      trigger: ".homepage-slider",
      start: 'top bottom-=20px',
      fastScrollEnd: true,
      once: true,
      end: "bottom 80%", 
      toggleClass: 'twk-aos-animating',
      onEnter: () => section.classList.add('twk-aos-animate'),
      onLeave: () => section.classList.add('twk-aos-animated'),
      animation: mobileSliderTL
    })

    const mobileStatsTL = gsap.timeline({ paused: false, });  
    mobileStatsTL.fromTo( homepageStatsTitle, { opacity: 0, y: 70, }, { opacity: 1, y: 0, ease: "none", }, ">" );
    mobileStatsTL.fromTo( homepageStatSlider, { opacity: 0, y: 70, }, { opacity: 1, y: 0, ease: "none", }, ">" );
    mobileStatsTL.fromTo( homepageIsi, { opacity: 0, y: 70, }, { opacity: 1, y: 0, ease: "none", }, ">" );
    ScrollTrigger.create({
      trigger: ".js-stats-title",
      start: 'top bottom-=80px',
      fastScrollEnd: true,
      once: true,
      end: "bottom 80%", 
      toggleClass: 'twk-aos-animating',
      onEnter: () => section.classList.add('twk-aos-animate'),
      onLeave: () => section.classList.add('twk-aos-animated'),
      animation: mobileStatsTL
    })
    

  } else {
    // Large screens

    // Don't allow user to scroll until banner animation is done
    if ( $('body').hasClass('home') ) {
      $('body').addClass('no-scroll');
    }

    gsap.set(homepageSlider, {opacity: 0 });
    logo.addClass('fixed-logo');
    
  
    // Banner Loading animation
    const loadBannerTL = gsap.timeline();
    loadBannerTL.add( function() { navButton.addClass('light'); } );
    loadBannerTL.from( homepageBannerImage, { clipPath: "inset(0% 100% 0% 0%)", duration: 1.2, ease: "power2.inOut" });
    loadBannerTL.from( homepageBannerTitle, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerTL.from( homepageBannerIntro, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.0" );
    loadBannerTL.from( homeBannerCrest, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.2" );
    loadBannerTL.from( logo, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=0.9" );
    loadBannerTL.from( navButton, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.2" );
    loadBannerTL.add(function () { $("body").removeClass("no-scroll"); }, ">");
    
    // Banner scroll animation
    // Timeout function so that scrolltrigger animation doesn't interfere with loading animation
    setTimeout(()=> {
      const bannerScrollTL = gsap.timeline({
        ease: 'none',
        scrollTrigger: {
          trigger: ".scroll-section-one",
          pin: true,
          pinSpacing: true,
          scrub: 0.1,
          start: "top top",
          end: "185% top",
          //toggleActions: "play pause play reset",
          onEnter: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.add( 'light' )
            document.querySelector( '#page-wrap' ).classList.add( 'fixed-gold-bar' )
          },
          onEnterBack: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.add( 'light' )
            document.querySelector( '#page-wrap' ).classList.add( 'fixed-gold-bar' )
          },
          onLeave: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.remove( 'light' )
            document.querySelector( '#page-wrap' ).classList.remove( 'fixed-gold-bar' )
          },
          onLeaveBack: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.remove( 'light' )
            document.querySelector( '#page-wrap' ).classList.remove( 'fixed-gold-bar' )
          },
        }
      });
    
      bannerScrollTL.fromTo( homepageBannerImage, { clipPath: "inset(0% -5% 0% 0%)" }, { clipPath: "inset(0% 100% 0% 0%)",  } );
      bannerScrollTL.fromTo( homepageBannerTitle, { clipPath: "inset(0% 0% -5% 0%)" },  { clipPath: "inset(0% 0% 100% 0%)" }, "<" );
      bannerScrollTL.fromTo( homepageBannerIntro, { opacity: 1 }, { opacity: 0 }, "<" );
      bannerScrollTL.set( homepageSliderSection, { xPercent: -100, opacity: 1}, '>'  );
      bannerScrollTL.fromTo( homepageSliderTitle, { clipPath: "inset(0% 0% 100% 0%)" }, { clipPath: "inset(0% 0% -5% 0%)" }, "<" );
      bannerScrollTL.to( homepageSlider, { opacity: 1 }, "<" );
      bannerScrollTL.fromTo( homepageSliderSlideOne, { clipPath: "inset(100% 0% 0% 0%)" }, { clipPath: "inset(0% 0% 0% 0%)" }, "<" );
      bannerScrollTL.fromTo( homepageSliderSlideThree, { clipPath: "inset(100% 0% 0% 0%)" }, { clipPath: "inset(0% 0% 0% 0%)" }, "<+0.04" );
      bannerScrollTL.fromTo( homepageSliderSlideTwo, { clipPath: "inset(100% 0% 0% 0%)" }, { clipPath: "inset(0% 0% 0% 0%)" }, "<+0.05" );
      
      
  
  
      
      // Stat and video section  
      const statsScrollTL = gsap.timeline({
        delay: bannerScrollTL.duration(),
        ease: 'none',
        scrollTrigger: {
          trigger: ".scroll-section-two",
          pin: true,
          pinSpacing: true,
          scrub: 0.1,
          start: "top top",
          end: "195% top",
          //toggleActions: "play pause play reset",
          onEnter: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.add( 'dark' )
            document.querySelector( '.top-nav__logo' ).classList.add( 'fixed-logo' )
            document.querySelector( '.top-nav__logo.white' ).classList.add( 'hidden' )
            document.querySelector( '.top-nav__logo.dark' ).classList.remove( 'hidden' )
          },
          onEnterBack: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.add( 'dark' )
            document.querySelector( '.top-nav__logo' ).classList.add( 'fixed-logo' )
            document.querySelector( '.top-nav__logo.white' ).classList.add( 'hidden' )
            document.querySelector( '.top-nav__logo.dark' ).classList.remove( 'hidden' )
          },
          onLeave: () => {
            document.querySelector( '.top-nav__logo' ).classList.remove( 'fixed-logo' )
            document.querySelector( '.top-nav__logo.white' ).classList.remove( 'hidden' )
            document.querySelector( '.top-nav__logo.dark' ).classList.add( 'hidden' )
          },
          onLeaveBack: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.remove( 'dark' )
            document.querySelector( '.top-nav__logo.white' ).classList.remove( 'hidden' )
            document.querySelector( '.top-nav__logo.dark' ).classList.add( 'hidden' )
          },
        }
      });
    
      statsScrollTL.set( homepageVideo, { xPercent: -100, opacity: 1}, '<'  );
      statsScrollTL.fromTo( homepageVideo, { clipPath: "inset(0% 0% 0% 100%)" }, { clipPath: "inset(0% 0% 0% -5%)",  }, "<" );
  
      ScrollTrigger.sort();
    }
    , 1900);

  } // End large screens
    



}




function homeAnimation() {
  homeBannerAnimation();
}

export default homeAnimation;
